import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ControlContainer } from "@angular/forms";
import { CampoSpecificoFascicolazioneDTO } from "@app/shared/dto/campo-specifico-fascicolazioneDTO";
import { SiNoEnum } from "@app/shared/enum/si-no-enum";
import { TipoFormEnum } from "@app/shared/enum/tipo-form.enum";
import { CampoSpecificoFascicolazioneVO } from "@app/shared/vo/campo-specifico-fascicolazioneVO";

@Component({
  selector: "app-valore-campo-specifico-libero",
  templateUrl: "./valore-campo-specifico-libero.component.html",
})
export class ValoreCampoSpecificoLiberoComponent implements OnInit {
  @Input()
  obbligatorio: boolean;
  @Input()
  valore: string;
  @Input()
  ultimo: boolean;
  @Input()
  campo: CampoSpecificoFascicolazioneVO;
  @Input()
  tipoForm: TipoFormEnum;
  @Output()
  emitAggiungiNuovo: EventEmitter<string> = new EventEmitter();
  @Output()
  emitValore: EventEmitter<string> = new EventEmitter();
  @Output()
  emitRimuovi: EventEmitter<string> = new EventEmitter();
  valoreDigitato: string;
  digitazioneTerminata: boolean = false;
  ngOnInit() {
    if (this.valore) {
        this.valoreDigitato =  this.valore;
        this.digitazioneTerminata = true;
    }
  }

  aggiungiNuovoValore() {
    this.emitAggiungiNuovo.emit();
    this.digitazioneTerminata = true;
  }
  valorizza(valoreDigitato: string) {
    this.valoreDigitato = valoreDigitato;
    this.emitValore.emit(valoreDigitato);
  }

  rimuovi() {
    this.emitRimuovi.emit();
  }

  getDisabledPlus() {
    switch (this.tipoForm) {
      case TipoFormEnum.MODIFICA:
        if (this.ultimo) {
          return false;
        } else {
          return true;
        }
      case TipoFormEnum.CREAZIONE: 
      if (this.digitazioneTerminata) {
          return true;
        } else {
          return false;
        }
    }
  }

  getPlusVisible() {
    switch (this.tipoForm) {
      case TipoFormEnum.MODIFICA:
        if (this.campo.ripetibile === SiNoEnum.SI && this.valoreDigitato) {
          return true;
        }
        break;
      case TipoFormEnum.CREAZIONE: 
      if (this.campo.ripetibile === SiNoEnum.SI && this.valoreDigitato) {
          return true;
        }
    }
    return false;
  }

  getMinusVisible() {
    switch (this.tipoForm) {
      case TipoFormEnum.MODIFICA:   
      if (this.valoreDigitato) {
          return true;
        }
        break;
      case TipoFormEnum.CREAZIONE:
        if (this.valoreDigitato) {
          return true;
        }
    }

    return false;
  }
}
